// import React, {
//   createContext,
//   useContext,
//   useState,
//   useEffect,
//   useCallback,
//   useRef,
// } from "react";

// import { getCurrentUser, getCurrentUserBasic } from "../services/auth";
// import { ServicesService } from "../api";
// import { filterExcludedServices } from "../utils/serviceFilters";
// import { UserBaseOut } from "@/api";
// import { authService } from "../auth/services/authService";

// // ============================================================
// // TYPES
// // ============================================================

// export interface Service {
//   id: number;
//   name: string;
// }

// export interface AuthPrincipal {
//   auth_user_id: number;
//   email: string;
//   name: string | null;
// }

// export interface UserBasicData {
//   id: number | null;
//   auth_user_id: number;
//   email: string | null;
//   name: string | null;

//   is_guest: boolean;

//   user_type_id: number;
//   user_role_id: number | null;

//   user_type: string | null;
//   role_name: string | null;
// }

// export type UserDetails = UserBaseOut;

// export interface UserContextType {
//   principal: AuthPrincipal | null;
//   basicData: UserBasicData | null;
//   user: UserDetails | null;

//   token: string | null;

//   services: Service[];

//   loading: boolean;

//   setToken: (token: string | null) => void;
//   setUser: (user: UserDetails | null) => void;

//   refreshUser: () => Promise<void>;

//   initializeSession: (
//     accessToken?: string
//   ) => Promise<UserBasicData | null>;

//   loadUserDetails: () => Promise<UserDetails | null>;

//   logout: () => void;
  
// }

// // ============================================================
// // CONTEXT
// // ============================================================

// const UserContext = createContext<UserContextType>({
//   principal: null,
//   basicData: null,
//   user: null,

//   token: null,
//   services: [],

//   loading: true,

//   setToken: () => {},
//   setUser: () => {},

//   refreshUser: async () => {},

//   initializeSession: async () => null,

//   loadUserDetails: async () => null,

//   logout: () => {},
// });

// // ============================================================
// // PROVIDER
// // ============================================================

// export const UserProvider: React.FC<{
//   children: React.ReactNode;
// }> = ({ children }) => {
//   // ==========================================================
//   // STATE
//   // ==========================================================

//   const [token, setTokenState] = useState<string | null>(
//     () => authService.getAccessToken()
//   );

//   const [principal, setPrincipal] =
//     useState<AuthPrincipal | null>(null);

//   const [basicData, setBasicData] =
//     useState<UserBasicData | null>(null);

//   const [user, setUser] =
//     useState<UserDetails | null>(null);

//   const [services, setServices] =
//     useState<Service[]>([]);

//   const [loading, setLoading] =
//     useState(true);

//   // ==========================================================
//   // INITIALIZATION CONTROL
//   // ==========================================================

//   /**
//    * Single-flight initialization.
//    *
//    * If initializeSession() is already running, every caller
//    * receives the same Promise instead of making another
//    * /me/basic request.
//    */
//   const initializationPromiseRef =
//     useRef<Promise<UserBasicData | null> | null>(null);

//   // ==========================================================
//   // TOKEN
//   // ==========================================================

//   const setToken = useCallback(
//     (newToken: string | null) => {
//       console.log(
//         "🔑 UserContext setToken:",
//         newToken
//           ? "TOKEN PRESENT"
//           : "TOKEN CLEARED"
//       );

//       setTokenState(newToken);
//     },
//     []
//   );

//   // ==========================================================
//   // TOKEN
//   // ==========================================================

//   const logout = useCallback(() => {
//   console.log("🚪 UserContext: Logging out");

//   // Stop using the persisted credentials.
//   authService.clearTokens();

//   // Clear authentication/session state.
//   setTokenState(null);
//   setPrincipal(null);
//   setBasicData(null);
//   setUser(null);
//   setServices([]);

//   // Reset loading state.
//   setLoading(false);

//   console.log("✅ UserContext: Session cleared");
// }, []);

//   // ==========================================================
//   // LOAD SERVICES
//   // ==========================================================

//   const loadServices = useCallback(
//     async (data: UserBasicData) => {
//       if (!data.user_type_id) {
//         console.log(
//           "ℹ️ No user_type_id; clearing services"
//         );

//         setServices([]);
//         return;
//       }

//       console.log(
//         "📦 Loading services for user type:",
//         data.user_type_id
//       );

//       const svc =
//         await ServicesService
//           .listServicesByClientTypeServicesUserTypeUserTypeIdGet(
//             data.user_type_id
//           );

//       const filteredServices =
//         filterExcludedServices(svc);

//       console.log(
//         "✅ Services loaded:",
//         filteredServices.length
//       );

//       setServices(filteredServices);
//     },
//     []
//   );

//   // ==========================================================
//   // LOAD BASIC DATA
//   // ==========================================================

//   const loadBasicData =
//     useCallback(async (): Promise<UserBasicData> => {
//       console.log(
//         "👤 Loading basic user data..."
//       );

//       const response =
//         await getCurrentUserBasic();

//       if (!response) {
//         throw new Error(
//           "GET /me/basic returned no user data"
//         );
//       }

//       const data: UserBasicData = {
//         id: response.id ?? null,

//         auth_user_id:
//           response.auth_user_id,

//         email:
//           response.email ?? "",

//         name:
//           response.name ?? "",

//         is_guest:
//           response.is_guest ?? true,

//         user_type_id:
//           response.user_type_id ?? 0,

//         user_role_id:
//           response.user_role_id ?? null,

//         user_type:
//           response.user_type ?? "",

//         role_name:
//           response.role_name ?? "",
//       };

//       setPrincipal({
//         auth_user_id:
//           response.auth_user_id,

//         email:
//           response.email ?? "",

//         name:
//           response.name ?? "",
//       });

//       setBasicData(data);

//       console.log(
//         "✅ Basic user data loaded:",
//         data
//       );

//       return data;
//     }, []);

//   // ==========================================================
//   // INITIALIZE SESSION
//   // ==========================================================

//   const initializeSession = useCallback(
//     async (
//       accessToken?: string
//     ): Promise<UserBasicData | null> => {
//       /**
//        * IMPORTANT:
//        *
//        * Explicit token wins.
//        *
//        * This is critical during AuthCallback because
//        * React state may not yet contain the token after
//        * setToken().
//        */
//       const activeToken =
//         accessToken ||
//         token ||
//         authService.getAccessToken();

//       if (!activeToken) {
//         console.warn(
//           "⚠️ initializeSession: No access token available"
//         );

//         setPrincipal(null);
//         setBasicData(null);
//         setServices([]);
//         setLoading(false);

//         return null;
//       }

//       /**
//        * IMPORTANT:
//        *
//        * Do not start another initialization if one is
//        * already running.
//        */
//       if (initializationPromiseRef.current) {
//         console.log(
//           "⏭️ initializeSession: already running; reusing existing request"
//         );

//         return initializationPromiseRef.current;
//       }

//       console.log(
//         "🔐 initializeSession: authenticated token available"
//       );

//       const promise =
//         (async (): Promise<UserBasicData | null> => {
//           try {
//             setLoading(true);

//             /*
//              * authService.setTokens() is expected to have
//              * happened before AuthCallback calls this method.
//              *
//              * For normal restoration, the token already exists
//              * in authService/localStorage.
//              */
//             const data =
//               await loadBasicData();

//             /*
//              * Services depend only on basicData.
//              */
//             await loadServices(data);

//             console.log(
//               "✅ initializeSession COMPLETE"
//             );

//             return data;

//           } catch (error) {
//             console.error(
//               "❌ initializeSession failed:",
//               error
//             );

//             setPrincipal(null);
//             setBasicData(null);
//             setServices([]);

//             return null;

//           } finally {
//             setLoading(false);

//             /*
//              * Allow the next explicit refresh/initialization
//              * after this request has completed.
//              */
//             initializationPromiseRef.current = null;
//           }
//         })();

//       initializationPromiseRef.current =
//         promise;

//       return promise;
//     },
//     [
//       token,
//       loadBasicData,
//       loadServices,
//     ]
//   );

//   // ==========================================================
//   // REFRESH USER
//   // ==========================================================

//   const refreshUser =
//     useCallback(async (): Promise<void> => {
//       console.log(
//         "🔄 refreshUser START"
//       );

//       const activeToken =
//         token ||
//         authService.getAccessToken();

//       if (!activeToken) {
//         setPrincipal(null);
//         setBasicData(null);
//         setServices([]);

//         return;
//       }

//       const data =
//         await initializeSession(
//           activeToken
//         );

//       if (!data) {
//         throw new Error(
//           "Unable to refresh user session"
//         );
//       }

//       console.log(
//         "✅ refreshUser COMPLETE"
//       );
//     }, [
//       token,
//       initializeSession,
//     ]);

//   // ==========================================================
//   // LOAD USER DETAILS
//   // ==========================================================

//   const loadUserDetails =
//     useCallback(async (): Promise<UserDetails | null> => {
//       console.log(
//         "📄 Loading complete user details..."
//       );

//       try {
//         const currentUser =
//           await getCurrentUser();

//         console.log(
//           "✅ Complete user details loaded:",
//           currentUser.id
//         );

//         setUser(currentUser);

//         return currentUser;

//       } catch (error) {
//         console.error(
//           "❌ Failed to load complete user details:",
//           error
//         );

//         setUser(null);

//         throw error;
//       }
//     }, []);

//   // ==========================================================
//   // AUTOMATIC SESSION RESTORATION
//   // ==========================================================

// useEffect(() => {
//   if (
//     location.pathname ===
//     "/authorize/callback"
//   ) {
//     console.log(
//       "⏭️ UserContext: skipping session restore on auth callback"
//     );

//     return;
//   }

//   const activeToken =
//     token || authService.getAccessToken();

//   if (!activeToken) {
//     setLoading(false);
//     return;
//   }

//   console.log(
//     "🔄 UserContext: Restoring existing session..."
//   );

//   void initializeSession(activeToken);
// }, [
//   location.pathname,
//   token,
//   initializeSession,
// ]);

//   // ==========================================================
//   // PROVIDER
//   // ==========================================================

//   return (
//     <UserContext.Provider
//       value={{
//         principal,
//         basicData,
//         user,

//         token,
//         services,

//         loading,

//         logout,

//         setToken,
//         setUser,

//         refreshUser,
//         initializeSession,

//         loadUserDetails,
//       }}
//     >
//       {children}
//     </UserContext.Provider>
//   );
// };

// // ============================================================
// // HOOK
// // ============================================================

// export const useUserContext =
//   () => useContext(UserContext);

import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";

import {
  getCurrentUser,
  getCurrentUserBasic,
} from "../services/auth";

import { ServicesService } from "../api";

import {
  filterExcludedServices,
} from "../utils/serviceFilters";

import { UserBaseOut } from "@/api";

import { authService } from "../auth/services/authService";


// ============================================================
// TYPES
// ============================================================

export interface Service {
  id: number;
  name: string;
}


// ============================================================
// AUTH PRINCIPAL
// ============================================================

/**
 * Authentication identity.
 *
 * Comes from the authentication token / AuthCallback.
 *
 * This does NOT imply that a local User record exists.
 */
export interface AuthPrincipal {
  auth_user_id: number;
  email: string;
  name: string | null;
}


// ============================================================
// BASIC USER DATA
// ============================================================

/**
 * Lightweight application identity.
 *
 * Comes from GET /me/basic.
 *
 * Exists for both registered and guest users.
 */
export interface UserBasicData {
  /**
   * Local User.id.
   *
   * Registered user:
   *   number
   *
   * Guest:
   *   null
   */
  id: number | null;

  auth_user_id: number;

  email: string | null;
  name: string | null;

  is_guest: boolean;

  user_type_id: number;

  user_role_id: number | null;

  user_type: string | null;

  role_name: string | null;
}


// ============================================================
// FULL USER
// ============================================================

/**
 * Full local User table representation.
 *
 * Loaded only when explicitly requested.
 */
export type UserDetails = UserBaseOut;


// ============================================================
// AUTHENTICATED SESSION
// ============================================================

/**
 * Result produced when an authenticated session has been
 * completely established.
 *
 * AuthCallback uses this object to decide where to navigate.
 *
 * UserProvider stores the same data in React state.
 */
export interface AuthenticatedSession {
  principal: AuthPrincipal;
  basicData: UserBasicData;
  services: Service[];
}


// ============================================================
// CONTEXT TYPE
// ============================================================

export interface UserContextType {
  // ----------------------------------------------------------
  // Authentication identity
  // ----------------------------------------------------------

  principal: AuthPrincipal | null;


  // ----------------------------------------------------------
  // Lightweight application identity
  // ----------------------------------------------------------

  basicData: UserBasicData | null;


  // ----------------------------------------------------------
  // Full local User
  // ----------------------------------------------------------

  user: UserDetails | null;


  // ----------------------------------------------------------
  // Authentication token
  // ----------------------------------------------------------

  token: string | null;


  // ----------------------------------------------------------
  // Available services
  // ----------------------------------------------------------

  services: Service[];


  // ----------------------------------------------------------
  // Loading state
  // ----------------------------------------------------------

  loading: boolean;


  // ----------------------------------------------------------
  // Token state
  // ----------------------------------------------------------

  setToken: (
    token: string | null
  ) => void;


  // ----------------------------------------------------------
  // Full user state
  // ----------------------------------------------------------

  setUser: (
    user: UserDetails | null
  ) => void;


  // ----------------------------------------------------------
  // AUTH CALLBACK / LOGIN
  // ----------------------------------------------------------

  /**
   * Establishes an authenticated session.
   *
   * This is the function AuthCallback calls after receiving
   * an access token.
   *
   * It:
   *
   *   GET /me/basic
   *        ↓
   *   principal
   *        ↓
   *   basicData
   *        ↓
   *   services
   *
   * It returns the exact session data used to populate
   * UserProvider.
   */
  establishSession: (
    accessToken: string
  ) => Promise<AuthenticatedSession | null>;


  // ----------------------------------------------------------
  // REFRESH
  // ----------------------------------------------------------

  /**
   * Reloads /me/basic and services for an existing session.
   */
  refreshUser: () => Promise<void>;


  // ----------------------------------------------------------
  // FULL USER
  // ----------------------------------------------------------

  /**
   * Loads the complete local User record.
   */
  loadUserDetails: () => Promise<UserDetails | null>;


  // ----------------------------------------------------------
  // LOGOUT
  // ----------------------------------------------------------

  /**
   * Clears authentication and all user state.
   */
  logout: () => void;
}


// ============================================================
// CONTEXT
// ============================================================

const UserContext =
  createContext<UserContextType>({
    principal: null,

    basicData: null,

    user: null,

    token: null,

    services: [],

    loading: true,

    setToken: () => {},

    setUser: () => {},

    establishSession:
      async (
        _accessToken: string
      ) => null,

    refreshUser:
      async () => {},

    loadUserDetails:
      async () => null,

    logout: () => {},
  });


// ============================================================
// PROVIDER
// ============================================================

export const UserProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children,
}) => {

  // ==========================================================
  // STATE
  // ==========================================================

  const [
    token,
    setTokenState,
  ] = useState<string | null>(
    authService.getAccessToken()
  );


  const [
    principal,
    setPrincipal,
  ] = useState<AuthPrincipal | null>(
    null
  );


  const [
    basicData,
    setBasicData,
  ] = useState<UserBasicData | null>(
    null
  );


  const [
    user,
    setUser,
  ] = useState<UserDetails | null>(
    null
  );


  const [
    services,
    setServices,
  ] = useState<Service[]>([]);


  const [
    loading,
    setLoading,
  ] = useState<boolean>(
    true
  );


  // ==========================================================
  // ASYNC CONTROL
  // ==========================================================

  /**
   * Prevents multiple simultaneous session requests.
   *
   * Particularly useful in React StrictMode development mode.
   */
  const sessionRequestRef =
    useRef<
      Promise<AuthenticatedSession | null> | null
    >(null);


  /**
   * Prevents stale async operations from writing state.
   */
  const sessionGenerationRef =
    useRef(0);


  // ==========================================================
  // TOKEN
  // ==========================================================

  const setToken = useCallback(
    (
      newToken: string | null
    ) => {

      console.log(
        "🔑 UserContext setToken:",
        newToken
          ? "TOKEN PRESENT"
          : "TOKEN CLEARED"
      );

      setTokenState(newToken);
    },
    []
  );


  // ==========================================================
  // LOAD BASIC DATA FROM API
  // ==========================================================

  const fetchBasicData =
    useCallback(
      async (): Promise<UserBasicData> => {

        console.log(
          "👤 Loading basic user data..."
        );

        const response =
          await getCurrentUserBasic();


        if (!response) {
          throw new Error(
            "GET /me/basic returned no user data"
          );
        }


        const data: UserBasicData = {
          id:
            response.id ??
            null,

          auth_user_id:
            response.auth_user_id,

          email:
            response.email ??
            "",

          name:
            response.name ??
            "",

          is_guest:
            response.is_guest ??
            true,

          user_type_id:
            response.user_type_id ??
            0,

          user_role_id:
            response.user_role_id ??
            null,

          user_type:
            response.user_type ??
            "",

          role_name:
            response.role_name ??
            "",
        };


        console.log(
          "✅ Basic user data loaded:",
          data
        );


        return data;
      },
      []
    );


  // ==========================================================
  // LOAD SERVICES
  // ==========================================================

  const fetchServices =
    useCallback(
      async (
        data: UserBasicData
      ): Promise<Service[]> => {

        if (!data.user_type_id) {

          console.log(
            "ℹ️ No user_type_id; no services"
          );

          return [];
        }


        console.log(
          "📦 Loading services for user type:",
          data.user_type_id
        );


        const svc =
          await ServicesService
            .listServicesByClientTypeServicesUserTypeUserTypeIdGet(
              data.user_type_id
            );


        const filteredServices =
          filterExcludedServices(
            svc
          );


        console.log(
          "✅ Services loaded:",
          filteredServices.length
        );


        return filteredServices;
      },
      []
    );


  // ==========================================================
  // BUILD PRINCIPAL
  // ==========================================================

  const buildPrincipal =
    useCallback(
      (
        data: UserBasicData
      ): AuthPrincipal => {

        return {
          auth_user_id:
            data.auth_user_id,

          email:
            data.email ??
            "",

          name:
            data.name ??
            null,
        };
      },
      []
    );


  // ==========================================================
  // ESTABLISH SESSION
  // ==========================================================

  /**
   * This is the SINGLE login/session initialization function.
   *
   * AuthCallback calls this after persisting the token.
   *
   * IMPORTANT:
   *
   * This function:
   *
   *   1. Fetches /me/basic
   *   2. Fetches services
   *   3. Populates UserProvider
   *   4. Returns the exact initialized session
   *
   * It does NOT cause another automatic initialization.
   */
  const establishSession =
    useCallback(
      async (
        accessToken: string
      ): Promise<AuthenticatedSession | null> => {

        if (!accessToken) {

          console.error(
            "❌ establishSession: No access token"
          );

          return null;
        }


        // ------------------------------------------------------
        // Reuse an already running request.
        // ------------------------------------------------------

        if (
          sessionRequestRef.current
        ) {

          console.log(
            "⏭️ establishSession: request already running; reusing it"
          );

          return (
            sessionRequestRef.current
          );
        }


        const generation =
          ++sessionGenerationRef.current;


        const request =
          (async () => {

            try {

              setLoading(true);


              console.log(
                "🔐 establishSession START"
              );


              // ------------------------------------------------
              // Token is already persisted by AuthCallback.
              // ------------------------------------------------

              const data =
                await fetchBasicData();


              // ------------------------------------------------
              // Load services.
              // ------------------------------------------------

              const loadedServices =
                await fetchServices(
                  data
                );


              // ------------------------------------------------
              // Build principal.
              // ------------------------------------------------

              const resolvedPrincipal =
                buildPrincipal(
                  data
                );


              // ------------------------------------------------
              // Don't write stale results.
              // ------------------------------------------------

              if (
                generation !==
                sessionGenerationRef.current
              ) {

                console.log(
                  "⏭️ establishSession: stale request ignored"
                );

                return null;
              }


              // ------------------------------------------------
              // Populate provider state ONCE.
              // ------------------------------------------------

              setTokenState(
                accessToken
              );

              setPrincipal(
                resolvedPrincipal
              );

              setBasicData(
                data
              );

              setServices(
                loadedServices
              );


              // A newly authenticated session should not
              // automatically contain stale full-user data.
              setUser(null);


              const session:
                AuthenticatedSession = {
                  principal:
                    resolvedPrincipal,

                  basicData:
                    data,

                  services:
                    loadedServices,
                };


              console.log(
                "✅ establishSession COMPLETE",
                {
                  authUserId:
                    data.auth_user_id,

                  role:
                    data.role_name,

                  isGuest:
                    data.is_guest,

                  services:
                    loadedServices.length,
                }
              );


              return session;

            } catch (error) {

              console.error(
                "❌ establishSession FAILED:",
                error
              );


              if (
                generation ===
                sessionGenerationRef.current
              ) {

                setPrincipal(null);

                setBasicData(null);

                setServices([]);

                setUser(null);
              }


              return null;

            } finally {

              if (
                generation ===
                sessionGenerationRef.current
              ) {

                setLoading(false);
              }

              sessionRequestRef.current =
                null;
            }
          })();


        sessionRequestRef.current =
          request;


        return request;
      },
      [
        fetchBasicData,
        fetchServices,
        buildPrincipal,
      ]
    );


  // ==========================================================
  // REFRESH USER
  // ==========================================================

  const refreshUser =
    useCallback(
      async (): Promise<void> => {

        const activeToken =
          token ||
          authService.getAccessToken();


        if (!activeToken) {

          console.log(
            "⏭️ refreshUser: no token"
          );

          return;
        }


        console.log(
          "🔄 refreshUser START"
        );


        try {

          setLoading(true);


          const data =
            await fetchBasicData();


          const loadedServices =
            await fetchServices(
              data
            );


          const resolvedPrincipal =
            buildPrincipal(
              data
            );


          setPrincipal(
            resolvedPrincipal
          );

          setBasicData(
            data
          );

          setServices(
            loadedServices
          );


          console.log(
            "✅ refreshUser COMPLETE"
          );

        } catch (error) {

          console.error(
            "❌ refreshUser FAILED:",
            error
          );

          throw error;

        } finally {

          setLoading(false);
        }
      },
      [
        token,
        fetchBasicData,
        fetchServices,
        buildPrincipal,
      ]
    );


  // ==========================================================
  // LOAD FULL USER
  // ==========================================================

  const loadUserDetails =
    useCallback(
      async (): Promise<UserDetails | null> => {

        console.log(
          "📄 Loading complete user details..."
        );


        try {

          const currentUser =
            await getCurrentUser();


          console.log(
            "✅ Complete user details loaded:",
            currentUser.id
          );


          setUser(
            currentUser
          );


          return currentUser;

        } catch (error) {

          console.error(
            "❌ Failed to load complete user details:",
            error
          );


          setUser(null);

          throw error;
        }
      },
      []
    );


  // ==========================================================
  // INITIAL SESSION RESTORATION
  // ==========================================================

  /**
   * This effect is intentionally:
   *
   *   - [] dependency
   *
   * It runs only when UserProvider mounts.
   *
   * It does NOT depend on `token`.
   *
   * This is important.
   *
   * AuthCallback changes the token during login. That must NOT
   * cause UserProvider to start another initialization.
   *
   * On a normal browser refresh, this effect restores the
   * existing persisted session.
   */
  useEffect(() => {

    let cancelled = false;


    const restoreSession =
      async () => {

        // ------------------------------------------------------
        // AUTH CALLBACK OWNS LOGIN INITIALIZATION
        // ------------------------------------------------------

        if (
          window.location.pathname ===
          "/authorize/callback"
        ) {

          console.log(
            "⏭️ UserContext: auth callback detected; skipping automatic restore"
          );

          setLoading(false);

          return;
        }


        // ------------------------------------------------------
        // Existing persisted token?
        // ------------------------------------------------------

        const existingToken =
          authService.getAccessToken();


        if (!existingToken) {

          console.log(
            "ℹ️ UserContext: no existing session"
          );


          if (!cancelled) {

            setPrincipal(null);

            setBasicData(null);

            setUser(null);

            setServices([]);

            setLoading(false);
          }


          return;
        }


        // ------------------------------------------------------
        // Restore existing session.
        //
        // establishSession deduplicates requests.
        // ------------------------------------------------------

        console.log(
          "🔄 UserContext: restoring existing session"
        );


        await establishSession(
          existingToken
        );


        if (
          cancelled
        ) {

          console.log(
            "⛔ UserContext: restoration cancelled"
          );

          return;
        }


        console.log(
          "✅ UserContext: existing session restored"
        );
      };


    void restoreSession();


    return () => {

      cancelled = true;

    };

  }, [
    establishSession,
  ]);


  // ==========================================================
  // LOGOUT
  // ==========================================================

  const logout =
    useCallback(
      () => {

        console.log(
          "🚪 UserContext: LOGOUT"
        );


        // ------------------------------------------------------
        // Invalidate any in-flight request.
        // ------------------------------------------------------

        sessionGenerationRef.current += 1;

        sessionRequestRef.current =
          null;


        // ------------------------------------------------------
        // Clear persisted authentication.
        // ------------------------------------------------------

        authService.clearTokens();


        // ------------------------------------------------------
        // Clear application metadata.
        // ------------------------------------------------------

        localStorage.removeItem(
          "authUserId"
        );

        localStorage.removeItem(
          "authEmail"
        );

        localStorage.removeItem(
          "authUserType"
        );


        // ------------------------------------------------------
        // Clear React state.
        // ------------------------------------------------------

        setTokenState(null);

        setPrincipal(null);

        setBasicData(null);

        setUser(null);

        setServices([]);

        setLoading(false);


        console.log(
          "✅ UserContext: LOGOUT COMPLETE"
        );
      },
      []
    );


  // ==========================================================
  // CONTEXT
  // ==========================================================

  return (
    <UserContext.Provider
      value={{
        principal,

        basicData,

        user,

        token,

        services,

        loading,

        setToken,

        setUser,

        establishSession,

        refreshUser,

        loadUserDetails,

        logout,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};


// ============================================================
// HOOK
// ============================================================

export const useUserContext =
  () => useContext(UserContext);